// A dropdown value for 'new process' that won't clash with user-defined names
export const newProcessChartValue = "new-process-jSg34892";
